import { useEffect, useState } from "react";

const LEFT_KEY = "mairko-matrix-sidebar-left";

/** Matches the CSS drawer breakpoint in styles.css. */
export const NARROW_MAX_PX = 720;

export function useNarrowViewport(maxPx = NARROW_MAX_PX): boolean {
	const [narrow, setNarrow] = useState(() =>
		typeof window !== "undefined"
			? window.matchMedia(`(max-width: ${maxPx}px)`).matches
			: false,
	);
	useEffect(() => {
		const mq = window.matchMedia(`(max-width: ${maxPx}px)`);
		const onChange = () => setNarrow(mq.matches);
		onChange();
		mq.addEventListener("change", onChange);
		return () => mq.removeEventListener("change", onChange);
	}, [maxPx]);
	return narrow;
}

export function readLeftSidebarOpen(): boolean {
	try {
		const raw = localStorage.getItem(LEFT_KEY);
		if (raw === null) return true;
		return raw === "1";
	} catch {
		return true;
	}
}

export function writeLeftSidebarOpen(open: boolean): void {
	try {
		localStorage.setItem(LEFT_KEY, open ? "1" : "0");
	} catch {
		/* ignore */
	}
}
